<template>
  <div>
    <v-row class="ma-0">
      <v-btn small>問{{ !$route.params.id ? Number(no) + 1 : Number(no) }}</v-btn>
    </v-row>
    <v-row class="mx-0 mt-2 lead-sentence">
      <span class>{{ formGeneral.leadSentence }}</span>
    </v-row>
    <v-row class="mx-0 mt-2">
      <span class="font-weight-bold mr-2">問題:</span>
      <span>{{ formGeneral.name1 }}</span>
    </v-row>
    <v-row class="mx-0 mt-5" justify="center">
      <v-img
        max-height="280"
        height="200"
        max-width="270"
        v-if="formGeneral.image"
        :lazy-src="formGeneral.image.fileUrl"
        :src="formGeneral.image.fileUrl"
        aspect-ratio="1.7"
        contain
      ></v-img>
      <v-img
        max-height="280"
        height="200"
        max-width="270"
        v-else
        class="mb-2"
        lazy-src="@/assets/defaultImage.jpg"
        src="@/assets/defaultImage.jpg"
        aspect-ratio="1.7"
        contain
      ></v-img>
    </v-row>
    <v-row class="mx-0 mt-5">
      <v-col
        :cols="!checkLength ? 6 : 12"
        v-for="(answers, index) in formGeneral.answers"
        :key="index"
      >
        <button class="width-10 pa-1 grey lighten-4 button-template">
          {{ answers.value ? answers.value : answers.name }}
        </button>
      </v-col>
    </v-row>
  </div>
</template>
<script>
export default {
  props: ["no"],
  store: ["formGeneral"],
  data() {
    return {
      keyAudio: 0,
      defaultValue: ["ご飯の後", "ご飯の前", "寝る前", "ご飯の間"],
    };
  },
  watch: {
    "formGeneral.audio": function () {
      this.keyAudio++;
    },
  },
  computed: {
    checkLength() {
      return Boolean(this.formGeneral.answers.find((e) => e.value.length > 9));
    },
  },
  methods: {
    play() {
      if (this.$refs.audioTemplate.paused) {
        this.$refs.audioTemplate.play();
      } else {
        this.$refs.audioTemplate.pause();
      }
    },
  },
};
</script>
<style scoped>
.lead-sentence {
  white-space: pre-wrap;
  padding-bottom: 8px;
  border-bottom: 5px dotted #feb798;
}
button {
  word-wrap: break-word;
}
</style>